module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"newLifekey":"En ny livsnøkkel","newBelt":"Yay, du er nå {beltName}!","belt":"belte","rankText":"Din ranking: {rank}","continueButton":"Forstett"},"en":{"newLifekey":"A new life key","newBelt":"Yay, you\u0027re a {beltName}!","belt":"belt","rankText":"Your Rank: {rank}","continueButton":"Continue"}}')
  delete Component.options._Ctor
}
